import React from "react";

function HighlightText({ text = "", highlight = "" }) {
  if (!highlight || !text) return text;

  // Escape special characters in each tag
  const escapeRegExp = (string) =>
    string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const tags = highlight.split(" ").map(escapeRegExp);
  const matches = [...text.matchAll(new RegExp(tags.join("|"), "ig"))];
  const startText = text.slice(0, matches[0]?.index);
  return (
    <>
      {startText}
      {matches.map((match, i) => {
        const startIndex = match.index;
        const currentText = match[0];
        const endIndex = startIndex + currentText.length;
        const nextIndex = matches[i + 1]?.index;
        const untilNextText = text.slice(endIndex, nextIndex);
        return (
          <span key={i}>
            <span style={{ fontWeight: 600 }}>{currentText}</span>
            {untilNextText}
          </span>
        );
      })}
    </>
  );
}

export default HighlightText;
